<template>
<section>
  <div class="form-group">
    <label>Customer</label>
    <multiselect id="customerMultiselect"
                 :options="customers"
                 v-model="selectedCustomerTemp"
                 :allow-empty="false"
                 placeholder="Select Customer"
                 track-by="name"
                 label="name"
                 :max-height="150"
                 >
    </multiselect>
  </div>
</section>
</template>

<script>
import Multiselect from "vue-multiselect";
import {getAllCustomersUsingWildCard, getAllUsersUsingWildCard} from "../../api/customers";

export default {
  name: "SearchCustomerByNameAndContactNumber",
  components: {Multiselect},
  data () {
    return {
      selectedCustomerTemp: null,
      customers: [],
    }
  },
  props: {
    baykedOrders: {
      type: Boolean,
      required: true,
    },
    isDeleted: {
      type: String,
      required: false,
    },
    getUsers: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    selectedCustomerTemp (val) {
      this.$emit('selectedCustomer', val);
    },
    customers: {
      handler() {
      },
      deep: true
    },
  },
  mounted() {
    this.getCustomer()
  },
  methods: {
    async searchCustomer () {
      let self = this;
      let wild_card = $("#customerMultiselect").val();
      if(wild_card !== "" && wild_card.length > 3 ) {
        this.customers = []
        let params = new URLSearchParams();
        params.append("wild_card", wild_card);
        params.append("bayked_orders", this.baykedOrders);
        if (this.isDeleted !== null && this.isDeleted !== undefined) {
          params.append("is_deleted", this.isDeleted);
        }
        let allCustomersResp = await (this.getUsers ? getAllUsersUsingWildCard(params) : getAllCustomersUsingWildCard(params)).catch(ex => {
          this.showErrorMessage(ex);
        });
        this.formatCustomerList(allCustomersResp.data, wild_card);
      }
    },
    formatCustomerList: function(allCustomers, wild_card){
      let self = this;
      allCustomers.map(function(arrr) {
        if (wild_card[0] === '0' && arrr.contact_number.includes('+92')) {
          arrr.contact_number = arrr.contact_number.replace('+92', '0')
        }
        arrr.contact_number = arrr.contact_number.split('&')[0];
        let name = `${arrr.name} ${arrr.contact_number}`;
        self.customers.push({
          id: arrr.id,
          name: name
        });
      });
    },
    getCustomer() {
      let self = this;
      $('#customerMultiselect').keydown(function(event){
        var id = event.key || event.which || event.keyCode || 0;
        if (id == 13 || id=='Enter') {
          self.searchCustomer();
        }
      });
    }
  }
}
</script>

<style scoped>

</style>